module.exports = __webpack_public_path__ + "static/media/baranovskyi_headshot.6f55eac4.png";